import { useEffect, useRef } from "react";
import { Card, Form, Input } from "../../components/UI/Layout";
import { useAppSelector, useAppDispatch } from "../../hooks";
import { updateOrderCustomer } from "../../store/order";

interface IProps {
  required?: string[];
}

export const FormDepartmentCode = ({
  required = [],
}: IProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const inputRef = useRef(null);

  const { customer = { departmentCode: "" } } = useAppSelector(
    (state) => ({
      customer: state.order.customer,
    })
  );

  useEffect(() => {
    if (inputRef) {
      inputRef.current!.focus({
        cursor: "all",
      });
    }
  }, []);

  const onFormChange = (fieldsValue: any) => {
    updateOrderCustomer({ ...customer, ...fieldsValue })(dispatch);
  };

  const { departmentCode } = customer;

  return (
    <Card bordered={false} id="form-customer">
      <Form layout="vertical" name="department-code-form" onValuesChange={onFormChange}>

          <Form.Item label="Department Code">
            <Form.Item
              name="departmentCode"
              noStyle
              rules={[
                {
                  required: required.includes("departmentCode"),
                  message: "Department Code is required",
                },
              ]}
            >
              <Input
                ref={inputRef}
                value={customer.departmentCode}
                placeholder="Please input Department Code"
              />
            </Form.Item>
          </Form.Item>
      </Form>
    </Card>
  );
};
